import Vue from 'vue'
import VueRouter, { RouteConfig } from 'vue-router'
import NotFound from '@/views/NotFound/index.vue'
import { Component } from 'vue-property-decorator'

Component.registerHooks([
	'beforeRouteEnter',
	'beforeRouteUpdate',
	'beforeRouteLeave',
])

Vue.use(VueRouter)

const routes: Array<RouteConfig> = [
	{
		path: '/',
		name: 'Mission',
		component: () => import('@/views/HotSite/index.vue'),
		meta: { title: 'Oportunidade Tributária' },
	},

	{
		path: '*',
		component: NotFound,
		meta: { title: '' },
	},
]

const router = new VueRouter({
	mode: 'history',
	base: process.env.BASE_URL,
	routes,
	linkActiveClass: 'active',
})

router.afterEach((to) => {
	Vue.nextTick(() => {
		// @ts-ignore
		document.title =
			(to.meta.title ? to.meta.title + ' - ' : '') + 'Locatelli'
	})
})

export default router
